import { HOME_PATH, REGISTER_PATH } from "Routes/paths";
import {
  logo,
  passwordshow,
  passwordhide,
  erroricon,
} from "assets/icons/index";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginFormik } from "Forms/auth/loginFormik";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import ResetPasswordMethod from "./ResetPassword/ResetPasswordMethod";
import GenerateOtpResetPassword from "./ResetPassword/GenerateOtpResetPassword";
import ValidateOtpResetPassword from "./ResetPassword/ValidateOtpResetPassword";
import ResetPassword from "./ResetPassword/ResetPassword";

interface LoginProps {}

const Login = ({}: LoginProps) => {
  const { t, i18n } = useTranslation();
  const formik = useLoginFormik();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  // reset password states
  const [activePop, setActivePop] = useState("");
  const [resetPasswordMethod, setResetPasswordMethod] = useState(0);
  const [countryCode, setCountryCode] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [email, setEmail] = useState("");

  const { loginLoading } = useSelector(
    (state: RootState) => state.loginReducer
  );

  return (
    <>
      <main className="py-[80px] px-[40px] w-full h-screen bg-gradient-to-r flex items-center justify-center relative">
        <section className="w-full flex flex-col items-center justify-center gap-[60px]">
          {/* logo section  **********************************/}
          <div className="w-[216px] h-[64px]">
            <img
              onClick={() => navigate(HOME_PATH)}
              className="w-full cursor-pointer"
              src={logo}
              alt="logo"
            />
          </div>

          {/* login form section  **********************************/}
          <Spin spinning={loginLoading}>
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="md:w-[424px] p-[25px] bg-white rounded-[20px] flex flex-col gap-[35px]"
            >
              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[20px] lg:text-[24px] text-second_color text-center whitespace-nowrap`}
              >
                {t("Sign in to your account")}
              </p>

              {/* Don't have an account? ****************************/}
              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[14px] lg:text-[16px] text-[#707070] text-center`}
              >
                {t("Don't have an account?")}{" "}
                <span
                  onClick={() => navigate(REGISTER_PATH)}
                  className="ml-[5px] text-first_color underline cursor-pointer"
                >
                  {t("Sign Up")}
                </span>
              </p>

              <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-[16px]"
              >
                {/* email section  **********************************/}
                <div>
                  <input
                    type="email"
                    placeholder={t("Email")}
                    name="email"
                    className={`w-full h-[48px] rounded-[10px] font-${
                      i18n.language === "en"
                        ? "Poppins pl-[24px]"
                        : "Almarai pr-[24px]"
                    } font-[400] text-[14px] lg:text-[16px] text-[#707070] border border-[#B6B6B6] `}
                    onChange={formik.handleChange}
                  />
                  {formik.errors.email ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.email}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/* password section  **********************************/}
                <div>
                  <div className="relative">
                    {" "}
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder={t("Password")}
                      name="password"
                      className={`w-full h-[48px] rounded-[10px] font-${
                        i18n.language === "en"
                          ? "Poppins pl-[24px]"
                          : "Almarai pr-[24px]"
                      } font-[400] text-[14px] lg:text-[16px] text-[#707070] border border-[#B6B6B6] `}
                      onChange={formik.handleChange}
                    />
                    <div
                      onClick={() => setShowPassword(!showPassword)}
                      className={`absolute ${
                        i18n.language === "en"
                          ? "top-[33%] right-[5%]"
                          : "top-[33%] left-[5%]"
                      }`}
                    >
                      {showPassword ? (
                        <img
                          className="cursor-pointer"
                          src={passwordhide}
                          alt="hide"
                        />
                      ) : (
                        <img
                          className="cursor-pointer"
                          src={passwordshow}
                          alt="show"
                        />
                      )}
                    </div>
                  </div>
                  {formik.errors.password ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.password}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/* forget password section  ***********************/}
                <p
                  onClick={() => setActivePop("resetPasswordMethod")}
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[14px] lg:text-[16px] text-first_color text-right cursor-pointer`}
                >
                  {t("Forget Your Password ?")}
                </p>

                {/* sign in button  **********************************/}
                <button
                  type="submit"
                  className={`mt-[20px] w-full h-[48px] bg-first_color rounded-[10px] text-white font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[14px] lg:text-[16px]`}
                >
                  {t("Sign in")}
                </button>
              </form>
            </div>
          </Spin>
        </section>
        <img
          className="absolute top-0 left-0 w-full h-full -z-10"
          src="../images/loginbg.png"
          alt=""
        />

        {/* reset password popups  ***********************************/}
        {activePop === "resetPasswordMethod" ? (
          <ResetPasswordMethod
            activePop={activePop}
            setActivePop={setActivePop}
            resetPasswordMethod={resetPasswordMethod}
            setResetPasswordMethod={setResetPasswordMethod}
          />
        ) : activePop === "generateOtpResetPassword" ? (
          <GenerateOtpResetPassword
            activePop={activePop}
            setActivePop={setActivePop}
            resetPasswordMethod={resetPasswordMethod}
            setEmail={setEmail}
            setPhoneNum={setPhoneNum}
            setCountryCode={setCountryCode}
          />
        ) : activePop === "validateOtpResetPassword" ? (
          <ValidateOtpResetPassword
            activePop={activePop}
            resetPasswordMethod={resetPasswordMethod}
            setActivePop={setActivePop}
            email={email}
            phoneNum={phoneNum}
            countryCode={countryCode}
          />
        ) : activePop === "resetPassword" ? (
          <ResetPassword
            activePop={activePop}
            email={email}
            phoneNum={phoneNum}
            resetPasswordMethod={resetPasswordMethod}
            setActivePop={setActivePop}
          />
        ) : (
          ""
        )}
      </main>
    </>
  );
};

export default Login;
